/**
 * Visual tokens for the analytics dashboard.
 *
 * The categorical palette is validated for colour-vision deficiency across every
 * pair, not just adjacent slots, because an admin can select any combination of
 * reps to compare. Four slots is the largest set that clears the all-pairs CVD
 * and normal-vision separation floors, which is why the rep comparison picker
 * caps at four — beyond that the lines stop being tellable apart.
 *
 * Do not add a fifth hue or reorder these without re-validating: a series colour
 * follows the entity it names, so reordering silently repaints existing charts.
 */

/** Categorical series colours, in fixed assignment order. */
export const SERIES_COLORS = ['#1d4ed8', '#ea580c', '#0891b2', '#be123c'] as const;

/** Maximum rep lines that can be overlaid on a trend chart. */
export const MAX_COMPARED_REPS = SERIES_COLORS.length;

/** The team-average line is ink rather than a hue, so it never competes with a series. */
export const TEAM_AVERAGE_COLOR = '#334155';

/** Recessive chart furniture. */
export const CHART_INK = {
  grid: '#e5e7eb',
  axis: '#cbd5e1',
  label: '#64748b',
  tooltipBorder: '#e2e8f0',
} as const;

/** Accent per summary card, used for the icon and the count only. */
export const CARD_ACCENTS = {
  sessions: '#475569',
  objections: '#ea580c',
  faqs: '#1d4ed8',
  newInquiries: '#0891b2',
  landmines: '#be123c',
  competitors: '#7c3aed',
} as const;

export const CHART_HEIGHT = 300;

/** Score axis is a 0-100 handling/adherence percentage in both trend charts. */
export const SCORE_AXIS_DOMAIN: [number, number] = [0, 100];
